import useCurrentUser from './useCurrentUser';

const useCurrentUserRole = () => {
	const currentUser = useCurrentUser();

	return currentUser?.role;
};

export default useCurrentUserRole;
